/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_Device_HintInputs */

const en_ui_laps_row_device_hint = /** @type {(inputs: Ui_Laps_Row_Device_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose splits in the Laps control`)
};

const de_ui_laps_row_device_hint = /** @type {(inputs: Ui_Laps_Row_Device_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle Splits über „Runden“`)
};

/**
* | output |
* | --- |
* | "Choose splits in the Laps control" |
*
* @param {Ui_Laps_Row_Device_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_device_hint = /** @type {((inputs?: Ui_Laps_Row_Device_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_Device_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_device_hint(inputs)
	return de_ui_laps_row_device_hint(inputs)
});